import store from '../store/index'

const routes = [
  {
    path: '/auth',
    component: () => import('../layouts/bareLayout.vue'),
    children: [
      {
        path: 'login',
        name: 'Login',
        component: () => import('../pages/auth/login.vue'),
        meta: { hasFlash: true, requiresUnAuth: true }
      },
      {
        path: 'logout',
        name: 'Logout',
        component: () => import('../pages/auth/login.vue'),
        beforeEnter: async (to, from, next) => {
          const logoutUrl = await store.dispatch('User/signOut')
          if (logoutUrl) {
            window.location.href = logoutUrl
          }
          next()
        },
        meta: { hasFlash: true, requiresAuth: true }
      },
      {
        path: 'confirm-email',
        name: 'ConfirmEmail',
        component: () => import('../pages/auth/confirmEmail.vue'),
        beforeEnter: async (to, from, next) => {
          await store.dispatch('User/signOut')
          next()
        },
        meta: { hasFlash: true }
      },
      {
        path: 'recover-password',
        name: 'RecoverPassword',
        component: () => import('../pages/auth/recoverPassword.vue'),
        beforeEnter: async (to, from, next) => {
          await store.dispatch('User/signOut')
          next()
        },
        meta: { hasFlash: true }
      },
      {
        path: 'forgot-password',
        name: 'ForgotPassword',
        component: () => import('../pages/auth/forgotPassword.vue'),
        beforeEnter: async (to, from, next) => {
          await store.dispatch('User/signOut')
          next()
        },
        meta: { hasFlash: true }
      }
    ]
  },
  {
    path: '/',
    component: () => import('../layouts/mainLayout.vue'),
    children: [
      {
        path: '',
        name: 'Home',
        component: () => import('../pages/home.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'user/account',
        name: 'Account',
        component: () => import('../pages/user/account.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'admin/alarms',
        name: 'Alarms',
        component: () => import('../pages/admin/alarms.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'admin/fileset/settings',
        name: 'Fileset Settings',
        components: {
          default: () => import('../pages/admin/fileset/settings.vue')
        },
        meta: { requiresAuth: true }
      },
      {
        path: 'admin/integrators',
        name: 'Integrators',
        component: () => import('../pages/admin/integrators.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'admin/integrator/settings',
        name: 'Integrator Settings',
        component: () => import('../pages/admin/integrator/settings.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'admin/groups',
        name: 'Groups',
        component: () => import('../pages/admin/groups.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'admin/group/settings',
        name: 'Group Settings',
        components: {
          default: () => import('../pages/admin/group/settings.vue')
        },
        meta: { requiresAuth: true }
      },
      {
        path: 'admin/group/permissions',
        name: 'Group Permissions',
        components: {
          default: () => import('../pages/admin/group/permissions.vue')
        },
        meta: { requiresAuth: true }
      },
      {
        path: 'admin/group/users',
        name: 'Group Users',
        components: {
          default: () => import('../pages/admin/group/users.vue')
        },
        meta: { requiresAuth: true }
      },
      {
        path: 'admin/organizations',
        name: 'Organizations',
        component: () => import('../pages/admin/organizations.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'admin/organization/settings',
        name: 'Organization Settings',
        components: {
          default: () => import('../pages/admin/organization/settings.vue')
        },
        meta: { requiresAuth: true }
      },
      {
        path: 'admin/organization/users',
        name: 'Organization Groups',
        components: {
          default: () => import('../pages/admin/organization/users.vue')
        },
        meta: { requiresAuth: true }
      },
      {
        path: 'admin/organization/client',
        name: 'Organization Client',
        components: {
          default: () => import('../pages/admin/organization/client.vue')
        },
        meta: { requiresAuth: true }
      },
      {
        path: 'admin/organization/systems',
        name: 'Organization Systems',
        components: {
          default: () => import('../pages/admin/organization/systems.vue')
        },
        meta: { requiresAuth: true }
      },
      {
        path: 'admin/retentions',
        name: 'Retentions',
        component: () => import('../pages/admin/retentions.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'admin/retention/settings',
        name: 'Retention Settings',
        components: {
          default: () => import('../pages/admin/retention/settings.vue')
        },
        meta: { requiresAuth: true }
      },
      {
        path: 'admin/retention/systems',
        name: 'Retention Systems',
        components: {
          default: () => import('../pages/admin/retention/systems.vue')
        },
        meta: { requiresAuth: true }
      },
      {
        path: 'admin/tags',
        name: 'Tags',
        component: () => import('../pages/admin/tags.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'admin/tag/settings',
        name: 'Tag Settings',
        components: {
          default: () => import('../pages/admin/tag/settings.vue')
        },
        meta: { requiresAuth: true }
      },
      {
        path: 'admin/rpiclients',
        name: 'RPI Clients',
        component: () => import('../pages/admin/rpiclients.vue'),
        meta: { requiresAuth: true, drawer: 'settings' }
      },
      {
        path: 'admin/scanresult',
        name: 'Scan Results',
        component: () => import('../pages/admin/scanresult/scanresult.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'admin/schedules',
        name: 'Schedules',
        component: () => import('../pages/admin/schedules.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'admin/schedule/settings',
        name: 'Schedule Settings',
        components: {
          default: () => import('../pages/admin/schedule/settings.vue')
        },
        meta: { requiresAuth: true }
      },
      // {
      //   path: 'admin/schedule/systems',
      //   name: 'Schedule Systems',
      //   components: {
      //     default: () => import('../pages/admin/schedule/systems.vue'),
      //     dataFetcher: () => import('../dataFetchers/schedule.vue')
      //   },
      //   meta: { requiresAuth: true }
      // },
      {
        path: 'admin/health-status',
        name: 'Not Backed Up',
        components: {
          default: () => import('../pages/admin/health-status.vue')
        },
        meta: { requiresAuth: true }
      },
      {
        path: 'admin/systems',
        name: 'Systems',
        component: () => import('../pages/admin/systems.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'admin/system/settings',
        name: 'System Settings',
        components: {
          default: () => import('../pages/admin/system/settings.vue')
        },
        meta: { requiresAuth: true }
      },
      {
        path: 'admin/system/backups',
        name: 'System Backups',
        components: {
          default: () => import('../pages/admin/system/backups.vue')
        },
        meta: { requiresAuth: true }
      },
      {
        path: 'admin/system/client',
        name: 'System Client',
        components: {
          default: () => import('../pages/admin/system/client.vue')
        },
        meta: { requiresAuth: true }
      },
      {
        path: 'admin/system/filesets',
        name: 'System Filesets',
        components: {
          default: () => import('../pages/admin/system/filesets.vue')
        },
        meta: { requiresAuth: true }
      },
      {
        path: 'admin/system/scans',
        name: 'System Scans',
        components: {
          default: () => import('../pages/admin/system/scans.vue')
        },
        meta: { requiresAuth: true }
      },
      {
        path: 'admin/system/purge',
        name: 'System Purge',
        components: {
          default: () => import('../pages/admin/system/purge.vue')
          // footer: () => import('../footers/systemFooter.vue')
        },
        meta: { requiresAuth: true }
      },
      {
        path: 'admin/orphans',
        name: 'Orphans',
        component: () => import('../pages/admin/orphans.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'admin/orphan/view',
        name: 'Orphans View',
        component: () => import('../pages/admin/orphan/view.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'admin/users',
        name: 'Users',
        component: () => import('../pages/admin/users.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'admin/user/settings',
        name: 'User Settings',
        components: {
          default: () => import('../pages/admin/user/settings.vue')
        },
        meta: { requiresAuth: true }
      },
      {
        path: 'admin/user/organizations',
        name: 'User Organizations',
        components: {
          default: () => import('../pages/admin/user/organizations.vue')
        },
        meta: { requiresAuth: true }
      },
      {
        path: 'admin/manual_scans',
        name: 'Manual Scans',
        components: {
          default: () => import('../pages/admin/manualScans.vue')
        }
      }
    ]
  },
  {
    path: '/unsubscribe',
    name: 'Unsubscribe',
    components: {
      default: () => import('../pages/unsubscribe.vue')
    }
  }
]

// Always leave this as last one
if (import.meta.env.QUASAR_MODE !== 'ssr') {
  routes.push({
    path: '/:catchAll(.*)*',
    component: () => import('../pages/error/404.vue')
  })
}

export default routes
